import { render } from "./DCard.vue?vue&type=template&id=049bd92f&scoped=true"
import script from "./DCard.vue?vue&type=script&lang=js"
export * from "./DCard.vue?vue&type=script&lang=js"

import "./DCard.vue?vue&type=style&index=0&id=049bd92f&lang=scss&scoped=true"

import exportComponent from "/assets/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-049bd92f"]])

export default __exports__